import { BaseAsset } from './BaseAsset';

export class MediaAsset extends BaseAsset {
    src: string;
    uploadStatus: string;
    isGlobal: string;
}